<dx-popup [title]="'_commons.connectionCheck' | translate" maxHeight="650" [(visible)]="visible" (onShown)="onShown()" (onHidden)="onHidden()">
    <div *dxTemplate="let data of 'content'">
        <dx-progress-bar width="100%"
                         [height]="15"
                         [value]="false"
                         [visible]="isProgressBarVisible" />
        <dx-scroll-view>
            <div class="form">
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.settings</div>
                    <div class="dx-field">
                        <dx-select-box displayExpr="name"
                                       [dataSource]="agents"
                                       [label]="('_commons.agent' | translate) + ' *'"
                                       [readOnly]="!canSelectAgent"
                                       [searchEnabled]="true"
                                       [(value)]="selectedAgent">
                        </dx-select-box>
                    </div>
                    <div class="dx-field">
                        <dx-select-box displayExpr="displayName"
                                       [dataSource]="remotePlatforms"
                                       [label]="('_commons.remotePlatform' | translate) + ' *'"
                                       [readOnly]="!canSelectRemotePlatform"
                                       [searchEnabled]="true"
                                       [(value)]="selectedRemotePlatform"
                                       (onSelectionChanged)="onSelectedRemotePlatformChange($event)">
                        </dx-select-box>
                    </div>
                    <div class="dx-field" *ngIf="selectedRemotePlatform?.isSFTP">
                        <dx-select-box displayExpr="name"
                                       valueExpr="id"
                                       [acceptCustomValue]="false"
                                       [items]="sftpEngines"
                                       [label]="('_commons.engine' | translate) + ' *'"
                                       [openOnFieldClick]="true"
                                       [searchEnabled]="false"
                                       [showDropDownButton]="true"
                                       [(value)]="sftpEngine">
                        </dx-select-box>
                    </div>
                    <div class="dx-field">
                        <dx-select-box [acceptCustomValue]="true"
                                       [dataSource]="remotePlatformDirectories"
                                       [label]="('_commons.directoryPath' | translate) + ' *'"
                                       [noDataText]="'_commons.noSuggestion' | translate"
                                       [openOnFieldClick]="true"
                                       [placeholder]="'_commons.directoryPathPlaceHolder' | translate"
                                       [searchEnabled]="true"
                                       [showDropDownButton]="false"
                                       [(value)]="directoryPath">
                        </dx-select-box>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.execution</div>
                    <div class="dx-field center">
                        <dx-button [disabled]="!this.selectedAgent || (!this.selectedRemotePlatform && !this.directoryPath)"
                                   [text]="'_commons.checkConnection' | translate"
                                   (onClick)="checkConnection()"></dx-button>
                    </div>
                    <div class="dx-field center" *ngIf="isCheckInProgress">
                        <dx-progress-bar #progressBar
                                         id="progress-bar-status"
                                         max="3"
                                         min="0"
                                         width="100%"
                                         [height]="15"
                                         [showStatus]="false"
                                         [value]="checkStep" />
                        <span>{{ checkProgression }}</span>
                    </div>
                </div>
            </div>
        </dx-scroll-view>
        <div class="flex bottom-buttons">
            <dx-button class="close closeButton" [text]="'_commons.close' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
    </div>
</dx-popup>

<app-local-agent-command #agentCommandPopup></app-local-agent-command>